import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { CetateanAccountsComponent } from './cetatean-accounts.component';
import { InfoCetateanComponent } from './info-cetatean/info-cetatean.component';

@NgModule({
    declarations: [CetateanAccountsComponent, InfoCetateanComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
    exports: [CetateanAccountsComponent],
})
export class CetateanAccountsModule { }
